import React from 'react'
import './ImageStyleSheet.css';

function RogerTwo() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/roger2.jpeg" className='img-view'/>
        </div>
    )
}

export default RogerTwo
